// extracted by mini-css-extract-plugin
export default {"container":"PlayerOverlay_container__TZEv4"};